import { Link2, FileText, AlertCircle, Database, BarChart3, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const DashboardPage = ({ stats, isLoading }) => {
  const statCards = [
    { label: "Linki", value: stats.total_links, icon: Link2, color: "text-blue-500" },
    { label: "Wszystkie oferty", value: stats.total_offers, icon: FileText, color: "text-slate-500" },
    { label: "Nowe", value: stats.new_offers, icon: AlertCircle, color: "text-emerald-500" },
    { label: "Dodane do bazy", value: stats.added_to_database, icon: Database, color: "text-purple-500" },
  ];

  return (
    <div className="space-y-4 sm:space-y-6 animate-fade-in" data-testid="dashboard-page">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight font-['Outfit']">Dashboard</h2>
        <p className="text-sm text-muted-foreground">Przegląd aktywności</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {statCards.map((stat) => (
          <Card key={stat.label} className="hover:shadow-md transition-shadow">
            <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-4 pb-1 sm:pb-2">
              <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground">
                {stat.label}
              </CardTitle>
              <stat.icon className={`w-4 h-4 sm:w-5 sm:h-5 ${stat.color}`} />
            </CardHeader>
            <CardContent className="p-3 sm:p-4 pt-0">
              <div className="text-xl sm:text-2xl font-bold font-mono">
                {isLoading ? "..." : stat.value}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <Card>
          <CardHeader className="p-3 sm:p-4">
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
              <BarChart3 className="w-4 h-4 sm:w-5 sm:h-5" />
              Dzisiaj
            </CardTitle>
          </CardHeader>
          <CardContent className="p-3 sm:p-4 pt-0 space-y-3">
            <div className="flex justify-between items-center p-2 sm:p-3 bg-muted rounded-lg">
              <span className="text-sm text-muted-foreground">Nowe oferty</span>
              <span className="font-mono font-bold">{stats.offers_today}</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="p-3 sm:p-4">
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              Status
            </CardTitle>
          </CardHeader>
          <CardContent className="p-3 sm:p-4 pt-0">
            <div className="flex items-center gap-3 p-2 sm:p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg">
              <div className="w-2 h-2 sm:w-3 sm:h-3 bg-emerald-500 rounded-full animate-pulse" />
              <span className="text-sm font-medium text-emerald-700 dark:text-emerald-400">
                Bot aktywny
              </span>
            </div>
            <p className="text-xs text-muted-foreground mt-2">Skanowanie co 5 minut</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DashboardPage;
